import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatButtonToggleModule, MatSlideToggleModule } from '@angular/material';
import { MaterialModule } from 'src/app/material/material.module';
import { ProcessesComponent } from './processes.component';
import { AutoPanelCreationComponent } from './auto-panel-creation/auto-panel-creation.component';
import { CandidateListModalComponent } from './candidate-list-modal/candidate-list-modal.component';
import { PanelMemberListModalComponent } from './panel-member-list-modal/panel-member-list-modal.component';
import { NotificationService } from 'src/app/shared/notification.service';
import { AutoPanelCreationService } from 'src/app/shared/auto-panelCreation/auto-panel-creation.service';
import { ProcessService } from 'src/app/shared/process-service/process.service';
import { PanelAssigningModule } from './panel-assigning/panel-assigning.module';
import { AssignedPanelDetsilsComponent } from './assigned-panel-detsils/assigned-panel-detsils.component';
import { AddMoreCandidateModelComponent } from './addMoreCandidateModel/add-more-candidate-model/add-more-candidate-model.component';
import { CreatePanelComponent } from './create-panel/create-panel.component';
import { PanelService } from 'src/app/shared/panel-service/panel.service';


@NgModule({
  declarations: [
    ProcessesComponent,
    AutoPanelCreationComponent,
    CandidateListModalComponent,
    PanelMemberListModalComponent,
    AssignedPanelDetsilsComponent,
    AddMoreCandidateModelComponent,
    CreatePanelComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    PanelAssigningModule,
    MatButtonToggleModule,
    MatSlideToggleModule
  ],
  entryComponents: [
    ProcessesComponent,
    AutoPanelCreationComponent,
    CandidateListModalComponent,
    PanelMemberListModalComponent,
    AssignedPanelDetsilsComponent,
    AddMoreCandidateModelComponent,
    CreatePanelComponent
  ],
  bootstrap: [ProcessesComponent],
  providers: [
    NotificationService,
    ProcessService,
    AutoPanelCreationService,
    PanelService
  ]
})
export class ProcessesModule { }
